import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

interface BackButtonOptions {
  text?: string;
  onClick: () => void;
}

interface Props {
  title: string;
  description?: string;
  backButtonOptions?: BackButtonOptions;
  rightSideComponent?: JSX.Element;
}

const FormsFilesHeader = ({
  title,
  description,
  backButtonOptions,
  rightSideComponent,
}: Props): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mb: 4,
      }}
    >
      {backButtonOptions && (
        <Box>
          <Button
            color="secondary"
            sx={{
              fontWeight: "bold",
            }}
            startIcon={<ArrowBackIosNewIcon />}
            onClick={backButtonOptions.onClick}
          >
            {backButtonOptions.text || "Back"}
          </Button>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h2" sx={{ mb: description ? 2 : 0 }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body1">{description}</Typography>
          )}
        </Box>
        {rightSideComponent}
      </Box>
    </Box>
  );
};

export default FormsFilesHeader;
